import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

// Context
import FeatureSwitchContext from "contexts/FeatureSwitch";

// Models
import FeatureFlags from "models/FeatureFlags/FeatureFlags";

// Hooks
import useModel from "hooks/useModel";

// For example of how to use Feature Flags, check out: https://github.com/collectivehealth/employer-portal/pull/756
// This PR has examples of removing previously used Feature Flags
function FeatureSwitchProvider({ children }) {
  const [featureFlagResource] = useModel(FeatureFlags, "getSingleConfig", {});

  const [featureFlags, setFeatureFlags] = useState({
    showProgramPartnersFeature: [false],
    showProcessedClaimsFilterOption: [false],
    showInsightsChart: [false],
    showProgramPartnersStats: [false],
    launchDarklyClientSideId: [""]
  });

  useEffect(() => {
    if (!featureFlagResource.isLoading) {
      const featureFlags = featureFlagResource.model.features;

      if (featureFlags && Object.keys(featureFlags).length) {
        setFeatureFlags({ ...featureFlags });
      }
    }
  }, [featureFlagResource.isLoading, featureFlagResource.model.features]);

  return (
    <FeatureSwitchContext.Provider
      value={{
        features: { ...featureFlags }
      }}
    >
      {children}
    </FeatureSwitchContext.Provider>
  );
}

FeatureSwitchContext.propTypes = {
  children: PropTypes.element
};

export default FeatureSwitchProvider;
